import pickBy from 'lodash/pickBy'

/**
 * Returns a new object with all undefined values removed.
 */
export function omitUndefined (obj) {
  return pickBy(obj, (value) => value !== undefined)
}



// WEBPACK FOOTER //
// ./src/client/utils/objectUtil.js